import addToCartActionTypes from '../actionTypes/AddToCartActionTypes';

const addItemToCart = (productDetail, analyticsData, from) => ({
    type: addToCartActionTypes.ADDTOCART_SITE_REQUEST,
    payload: { productDetail, analyticsData },
    from,
    sourceMiniPDP: productDetail.sourceMiniPDP,
});

const closeCartModal = () => ({
    type: addToCartActionTypes.ADDTOCART_SITE_KEEPSHOPPING_ONCLICK,
});

const resetCart = () => ({
    type: addToCartActionTypes.ADDTOCART_SITE_RESET,
});

const revieveATC = (payload) => ({
    type: addToCartActionTypes.REVIEVE_ADDTOCART_REQUEST,
    payload,
});

const getCartDetailsAction = (payload) => ({
    type: addToCartActionTypes.ADDTOCART_DETAILS_GET_REQUEST,
    payload,
});

export default {
    addItemToCart,
    closeCartModal,
    resetCart,
    revieveATC,
    getCartDetailsAction,
};
